var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "fideliteCardList" },
      _vm._l(_vm.groupFidCards, function (fidCard, i) {
        return _c(
          "li",
          {
            key: i,
            staticClass: "cursor-pointer mb-10",
            class: { disabled: !fidCard.nbPoints },
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "switch on-off-grey withTxt withLabelFullWith mb-0",
              },
              [
                _c(
                  "span",
                  { staticClass: "labelText flex-start-center pr-10" },
                  [
                    _c("small", { staticClass: "fsize-12 color-grey1" }, [
                      _vm._v("Carte nº" + _vm._s(fidCard.cardno)),
                    ]),
                    _c(
                      "em",
                      { staticClass: "fsize-12 text-italic ml-5 color-grey4" },
                      [
                        _vm._v(
                          "( " +
                            _vm._s(_vm.ShopService.prix(fidCard.nbPoints)) +
                            " )"
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.isFideliteCardUsed(fidCard) },
                  on: {
                    change: function ($event) {
                      return _vm.toggleFidelitePayment(fidCard)
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "slider round flex-shrink-0" }, [
                  _c(
                    "small",
                    { staticClass: "flex-center-center h-100 text-bold" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.isFideliteCardUsed(fidCard) ? "oui" : "non"
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }